var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.474 19.278C19.4806 19.0928 19.4149 18.9147 19.2968 18.7793L16.6645 15.915L16.0474 15.2524L19.2968 11.7255C19.3624 11.6543 19.4149 11.5759 19.4477 11.4904C19.4806 11.4049 19.5002 11.3123 19.5002 11.2196C19.5002 11.1199 19.4871 11.0273 19.4477 10.9418C19.4149 10.8563 19.369 10.7708 19.3099 10.7066C19.2442 10.6425 19.172 10.5855 19.0933 10.5499C19.0145 10.5143 18.9226 10.5 18.8373 10.5C18.7519 10.5 18.6666 10.5214 18.5812 10.557C18.5025 10.5926 18.4303 10.6496 18.3712 10.7138L15.0099 14.3621L11.6291 10.6924C11.5043 10.5642 11.3402 10.5001 11.1696 10.5001C10.9989 10.5001 10.8348 10.5784 10.7166 10.7067C10.5919 10.8421 10.5263 11.0131 10.5263 11.1983C10.5197 11.3836 10.5853 11.5617 10.7035 11.6971L13.3358 14.5613L13.9528 15.224L10.7035 18.7509C10.6378 18.8221 10.5853 18.9005 10.5525 18.986C10.5197 19.0715 10.5 19.1641 10.5 19.2567C10.5 19.3565 10.5131 19.4491 10.5525 19.5346C10.5853 19.6201 10.6313 19.7056 10.6904 19.7697C10.756 19.8339 10.8282 19.8909 10.907 19.9265C10.9858 19.9621 11.0777 19.9764 11.163 19.9764C11.2483 19.9764 11.3337 19.955 11.419 19.9194C11.4978 19.8837 11.57 19.8267 11.6291 19.7626L14.9903 16.1142L18.3712 19.7839C18.4959 19.9122 18.66 19.9763 18.8307 19.9763C19.0014 19.9763 19.1655 19.8979 19.2836 19.7697C19.4083 19.6343 19.474 19.4633 19.474 19.278Z",
    fill: "#181725"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.d41f25bbde30c8267dcee6f3887e2b7e.svg";
export { ForwardRef as ReactComponent };